import React, { useCallback } from 'react';

import { palette, Icon } from '@m12s/component-library';
import { plus } from 'lib/icons';
import styled from 'styled-components';
import { getUserAddedManualPartCounts } from 'lib/selectors/getUserAddedManualPartCounts';
import { actionSetUserAddedManualPartCounts } from 'lib/actions';
import { useDispatch, useSelector } from 'react-redux';
import { getMachine } from 'lib/selectors/getMachine';
import { now, toISO } from 'lib/utils/date';
import { CREATE_MANUAL_PART } from 'lib/api/mutations';
import { useMutation } from '@apollo/client';

const PrimaryWheelContent = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 12.688rem;
  width: 12.688rem;
  border-radius: 50%;
  background-color: ${palette.Indigo600};
  border: none;
`;

const PrimaryWheelContainer = styled.button`
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15.688rem;
  width: 15.688rem;
  border-radius: 50%;
  background-color: ${palette.Indigo400};
  border: none;
  cursor: pointer;
  opacity: ${(props) => {
    return props.disabled ? '0.5' : '1';
  }};
  ${(props) => {
    return (
      !props.disabled &&
      `
    &:hover ${PrimaryWheelContent} {
      background-color: #535CCC;
    }

    &:active ${PrimaryWheelContent} {
      background-color: ${palette.Indigo700};
    }
  `
    );
  }}
  ${(props) => {
    return (
      props.disabled &&
      `
    &,
    & ${PrimaryWheelContent} {
      cursor: not-allowed;
    }
  `
    );
  }}
`;

const ManualPartCountWheel = () => {
  const dispatch = useDispatch();
  const userAddedManualPartCounts = useSelector(getUserAddedManualPartCounts);
  const machine = useSelector(getMachine);

  const [requestCreateManualPart, { loading }] = useMutation(
    CREATE_MANUAL_PART,
    {
      fetchPolicy: 'no-cache',
    }
  );

  const isRequestDisabled = loading;

  const handleAddManualPartCount = useCallback(() => {
    if (isRequestDisabled) return;
    const newItem = {
      count: 1,
      partTime: toISO(now()),
    };

    requestCreateManualPart({
      variables: {
        input: {
          ...newItem,
          machineId: machine.id,
        },
      },
    });

    dispatch(
      actionSetUserAddedManualPartCounts([
        ...userAddedManualPartCounts,
        {
          ...newItem,
        },
      ])
    );
  }, [
    dispatch,
    userAddedManualPartCounts,
    machine,
    requestCreateManualPart,
    isRequestDisabled,
  ]);

  return (
    <PrimaryWheelContainer
      onClick={handleAddManualPartCount}
      disabled={isRequestDisabled}
    >
      <PrimaryWheelContent>
        <Icon icon={plus} size="3rem" color={palette.White} />
      </PrimaryWheelContent>
    </PrimaryWheelContainer>
  );
};

export { ManualPartCountWheel };
